import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import lsencryption from "./lsencryption";

let final_config;
let auth;
let db;
let storageRef;

const firebaseDataUrl = () => {
  const fireBaseData = lsencryption.get("firebaseConfig");
  let firebaseDataConfig = fireBaseData && JSON.parse(fireBaseData);
  // Dummy Object
  const firebaseDummyObj = {
    googleMapKey: "AIzaSyAk4_RjGS0QBVi6Waj-f2Qd0bK3gxuL4FU123",

    apiKey: "AIzaSyDtpp0BUeILDdkyx59aPbKy2aPjHNb9zj0123",

    authDomain: "oneimpact-uat-2.firebaseapp.com",

    databaseURL: "https://oneimpact-uat-2-default-rtdb.firebaseio.com",

    projectId: "oneimpact-uat-2",

    storageBucket: "oneimpact-uat-2.appspot.com",

    messagingSenderId: "703455620361123",

    appId: "1:703455620361:web:58c4c39f761d995d8137d8",

    measurementId: "G-7217VV29YM",

    serverKey:
      "AAAAo8k47Qk:APA91bEJQbeHQUFMoi1Z8wOe_w7yVnF7MSHO78U43ejfg0YqFAG3RmnKIArCBeWZdCzovPOXZgZZf2vG3clqO86y4OS-3yhFga0x9xvP202rOkcfsxCZ7juSk9Qs2gsUu86ziZVzVm8h",
  };

  if (firebaseDataConfig == "true") {
    firebaseDataConfig = firebaseDummyObj;
  }
  final_config = firebaseDataConfig;

  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseDataConfig);
  } else {
    firebase.app(); // if already initialized, use that one
  }

  auth = firebase.auth;

  db = firebase.database();
  storageRef= firebase.storage();
};

export { auth, final_config, db, storageRef, firebaseDataUrl };
